const translations = {
  en: {
    experience: "Experience",
    viewResume: "View Full Resume",
    experiences: [
      {
        date: "Jan 2026 — Present", //[cite: 7, 9]
        title: "Fullstack Developer @ JokiProyek", //[cite: 7, 9]
        link: "#",
        description: "Architecting and maintaining scalable web and mobile applications for diverse clients using React.js, Vue.js, Laravel, and Flutter. Led end-to-end mobile development (iOS & Android) and optimized backend database queries for high-traffic digital products.", //[cite: 7, 9, 10]
      },
      {
        date: "Feb 2026 — May 2026", //[cite: 7, 9]
        title: "AI Training Specialist @ Alignerr", //[cite: 7, 9]
        link: "#",
        description: "Evaluated AI-generated Python and TS/JS code to improve LLM accuracy and reasoning. Executed complex data labeling and RLHF (Reinforcement Learning from Human Feedback) workflows to eliminate hallucinations in technical AI outputs.", //[cite: 9, 10]
      },
      {
        date: "Jun 2023 — Present", //[cite: 7, 9]
        title: "Software Engineer @ Freelance", //[cite: 7, 9]
        link: "https://hasnurriungsinergi.co.id/",
        description: "Built comprehensive training management systems, responsive React.js landing pages, and resolved critical backend bugs. Delivered high-conversion web apps and platforms serving 1,000+ active users.", //[cite: 9, 10]
      },
      {
        date: "Jan — Apr 2025", //[cite: 7]
        title: "Frontend & Backend Developer Cohort @ DBS Foundation", //[cite: 7]
        link: "#",
        description: "Designed and developed the TrashLab waste classification website as UI/UX Lead in a 5-person team, winning the Best Capstone Project award. Graduated top of cohort.", //[cite: 9, 10]
      },
      {
        date: "Nov 2024 — Feb 2025", //[cite: 9]
        title: "Backend Developer @ PT Tanjung Alam Jaya", //[cite: 9]
        link: "#",
        description: "Built backend systems for the SISKA workplace safety mobile application. Integrated safety data management APIs and enhanced app functionality with a Flutter Dart frontend.", //[cite: 9, 10]
      },
      {
        date: "Sep 2024 — Feb 2025", //[cite: 9]
        title: "Backend Developer @ SMK Telkom Banjarbaru", //[cite: 9]
        link: "#",
        description: "Developed backend systems for a Village Cooperative mobile application serving Kandangan using Laravel. Integrated complex APIs for financial features including transfers, top-ups, and loans.", //[cite: 9, 10]
      },
    ],
    codedWith: "Coded with",
    builtWith: "Built with",
    deployedWith: "Deployed with",
    allTextSet: "All text is set in",
    visualStudioCode: "Visual Studio Code",
    react: "React.js",
    tailwindCSS: "Tailwind CSS",
    vercel: "Vercel",
    hack: "Hack",
  },
  id: {
    experience: "Pengalaman",
    viewResume: "Lihat Resume Lengkap",
    experiences: [
      {
        date: "Jan 2026 — Sekarang", //[cite: 7, 9]
        title: "Fullstack Developer @ JokiProyek", //[cite: 7, 9]
        link: "#",
        description: "Merancang arsitektur aplikasi web dan mobile yang skalabel menggunakan React.js, Vue.js, Laravel, dan Flutter. Memimpin pengembangan mobile end-to-end (iOS & Android) dan mengoptimalkan query database untuk produk ber-traffic tinggi.", //[cite: 7, 9, 10]
      },
      {
        date: "Feb 2026 — Mei 2026", //[cite: 7, 9]
        title: "AI Training Specialist @ Alignerr", //[cite: 7, 9]
        link: "#",
        description: "Mengevaluasi kode Python dan TS/JS buatan AI untuk meningkatkan akurasi LLM. Mengeksekusi pelabelan data kompleks dan alur kerja RLHF (Reinforcement Learning from Human Feedback) untuk menekan halusinasi pada model.", //[cite: 9, 10]
      },
      {
        date: "Jun 2023 — Sekarang", //[cite: 7, 9]
        title: "Software Engineer @ Freelance", //[cite: 7, 9]
        link: "https://hasnurriungsinergi.co.id/",
        description: "Membangun sistem manajemen pelatihan, landing page React.js responsif, dan memperbaiki bug backend kritis. Menyajikan aplikasi web dengan konversi tinggi dan platform acara yang melayani lebih dari 1.000 pengguna aktif.", //[cite: 9, 10]
      },
      {
        date: "Jan — Apr 2025", //[cite: 7]
        title: "Frontend & Backend Developer Cohort @ DBS Foundation", //[cite: 7]
        link: "#",
        description: "Merancang dan mengembangkan website klasifikasi sampah TrashLab sebagai UI/UX Lead dalam tim beranggotakan 5 orang, serta memenangkan penghargaan Best Capstone Project. Lulus sebagai lulusan terbaik.", //[cite: 9, 10]
      },
      {
        date: "Nov 2024 — Feb 2025", //[cite: 9]
        title: "Backend Developer @ PT Tanjung Alam Jaya", //[cite: 9]
        link: "#",
        description: "Membangun sistem backend untuk aplikasi mobile keselamatan kerja SISKA. Mengintegrasikan API manajemen data keselamatan dan menyempurnakan fungsi aplikasi bersama frontend Flutter Dart.", //[cite: 9, 10]
      },
      {
        date: "Sep 2024 — Feb 2025", //[cite: 9]
        title: "Backend Developer @ SMK Telkom Banjarbaru", //[cite: 9]
        link: "#",
        description: "Mengembangkan sistem backend aplikasi mobile Koperasi Unit Desa wilayah Kandangan menggunakan Laravel. Mengintegrasikan API kompleks untuk fitur keuangan termasuk transfer, top-up, dan pinjaman.", //[cite: 9, 10]
      },
    ],
    codedWith: "Dikodekan dengan",
    builtWith: "Dibangun dengan",
    deployedWith: "Dideploy dengan",
    allTextSet: "Semua teks diatur dalam",
    visualStudioCode: "Visual Studio Code",
    react: "React.js",
    tailwindCSS: "Tailwind CSS",
    vercel: "Vercel",
    hack: "Hack",
  },
};

export default translations;